import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { mapProductProjectionToListingProduct } from '../../../ProductListing/mappers/listing-product/map-product-projection-to-listing-product.js';
import { useGetProductsBySku } from '../../../utils/use-get-products-by-sku.js';
import { SimpleProductBlock } from './SimpleProductBlock.js';

const ProductBlocksContainer = ({ className , limit , reimbursableLogos , skus =[]  })=>{
    const intl = useIntl();
    const { products , isLoading  } = useGetProductsBySku(skus, limit);
    const classNames = classnames('product-blocks-container', {
        className,
        loading: isLoading
    });
    const listingProducts = React.useMemo(()=>products.map((hit)=>{
            return mapProductProjectionToListingProduct(hit, intl);
        }).filter(isDefined)
    , [
        products,
        intl
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, isLoading ? /*#__PURE__*/ React.createElement(Loader, null) : listingProducts.map((product)=>/*#__PURE__*/ React.createElement(SimpleProductBlock, {
            key: product.objectID,
            product: product,
            reimbursableLogos: reimbursableLogos
        })
    ));
};

export { ProductBlocksContainer, ProductBlocksContainer as default };
//# sourceMappingURL=ProductBlocksContainer.js.map
